export default __webpack_public_path__ + "static/screenshot-1-0513e3f4fea4f5869442786b77ae94e7.jpg";